import script from "./HeaderChatSearchPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderChatSearchPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderChatSearchPanel.vue?vue&type=style&index=0&id=345dcce7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345dcce7"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
